/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Status_AllInputs */

const id_reseller_pricing_status_all = /** @type {(inputs: Reseller_Pricing_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua status`)
};

const en_reseller_pricing_status_all = /** @type {(inputs: Reseller_Pricing_Status_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any status`)
};

/**
* | output |
* | --- |
* | "Any status" |
*
* @param {Reseller_Pricing_Status_AllInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_status_all = /** @type {((inputs?: Reseller_Pricing_Status_AllInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Status_AllInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_status_all(inputs)
	return id_reseller_pricing_status_all(inputs)
});